export const QUERY_COLLABORATOR_GROUPS_LIST_SIZE =
  "QUERY_COLLABORATOR_GROUPS_LIST_SIZE";
